import { useEffect, useState } from "react";
import style from "./about.module.css";
import logo from "../image/logo.jpg";
import coder from "../image/coder.png";

function About() {
  const [isInView, setIsInView] = useState(false);
  const [windowWidth, setWindowWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 0
  );

  useEffect(() => {
    // Handle resize with throttling for better performance
    let timeoutId;
    const handleResize = () => {
      if (timeoutId) clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        setWindowWidth(window.innerWidth);
      }, 100);
    };

    // Intersection Observer to trigger animations when section is visible
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsInView(true);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    const aboutSection = document.getElementById("about");
    if (aboutSection) {
      observer.observe(aboutSection);
    }

    window.addEventListener("resize", handleResize);
    
    return () => {
      window.removeEventListener("resize", handleResize);
      if (timeoutId) clearTimeout(timeoutId);
      if (aboutSection) observer.unobserve(aboutSection);
    };
  }, []);

  return (
    <section className={style.about_section} id="about">
      <div className={style.container}>
        <div className={`${style.image_column} ${isInView ? style.animate : ""}`}>
          <div className={style.image_card}>
            <div className={style.background_image}></div>
            <div className={style.logo_badge}>
              <img src={logo} className={style.logo} alt="Personal logo" />
            </div>
            <div className={style.coder_icon}>
              <img src={coder} className={style.coder_img} alt="Coder icon" />
            </div>
          </div>
          
          <div className={style.tech_pills}>
            <span className={style.pill}>React.js</span>
            <span className={style.pill}>Node.js</span>
            <span className={style.pill}>MongoDB</span>
            <span className={style.pill}>Express</span>
            <span className={style.pill}>Django</span>
          </div>
        </div>

        <div className={`${style.content_column} ${isInView ? style.animate : ""}`}>
          <div className={style.section_subtitle}>Discover My Journey</div>
          <h2 className={style.section_title}>About Me</h2>
          
          <div className={style.highlight_text}>
            MERN Stack Developer and Programming Instructor based in Kathmandu, Nepal
            <i className="fa-solid fa-house" aria-hidden="true"></i>
          </div>
          
          <div className={style.bio_text}>
            <p>
              I'm a passionate full-stack developer specializing in building impactful web solutions 
              with the MERN stack. Currently working at Sipalaya Info Tech Pvt.Ltd as a developer and instructor, 
              I leverage my BCS (Honours) education from Sunway International Business School to create 
              user-centric applications and mentor aspiring developers.
            </p>
            
            <ul className={style.skills_list}>
              <li><i className="fa-solid fa-check"></i> Full-Stack JavaScript Development</li>
              <li><i className="fa-solid fa-check"></i> React.js & Modern Frontend Frameworks</li>
              <li><i className="fa-solid fa-check"></i> Node.js, Express & RESTful APIs</li>
              <li><i className="fa-solid fa-check"></i> MongoDB, MySQL & Database Design</li>
              <li><i className="fa-solid fa-check"></i> Python, Django & Java Development</li>
              <li><i className="fa-solid fa-check"></i> Data Structures & Algorithms</li>
            </ul>
            
            <p>
              My portfolio includes successful projects like e-commerce platforms and restaurant management 
              systems. Beyond coding, I enjoy football, volleyball, and discovering new music. I'm always open 
              to collaborations on innovative projects that solve real-world challenges.
            </p>
            
            <div className={style.experience_stats}>
              <div className={style.stat}>
                <span className={style.stat_number}>1.5+</span>
                <span className={style.stat_label}>Years Experience</span>
              </div>
              <div className={style.stat}>
                <span className={style.stat_number}>10+</span>
                <span className={style.stat_label}>Projects Completed</span>
              </div>
              <div className={style.stat}>
                <span className={style.stat_number}>2200+</span>
                <span className={style.stat_label}>Hours Teaching</span>
              </div>
            </div>
            
            <a href="#contact" className={style.about_cta}>
              Get In Touch <i className="fa-solid fa-arrow-right"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;